import * as React from "react"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICharge } from "shared/hubrise/models"

const Delete = ({ charge }: { charge: ICharge }): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleClick = (): void => {
    navigate(catalogNavigation.editNextPath("charges"))
    editor.charge.delete(charge.id)
  }

  return <Details.TopbarButton onClick={handleClick} code="delete" />
}

export default Delete
